import { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';

interface Props {
    label: string;
    style?: React.CSSProperties;
    contentClassName?: string;
    contentStyle?: React.CSSProperties;
    children: JSX.Element;
}

export const ToggleGroup: React.FC<Props> = ({ style, label, contentClassName, contentStyle, children }) => {
    const [isShow, setIsShow] = useState(false);

    return (
        <div className="d-flex flex-column">
            <Button variant="secondary" style={style} onClick={useCallback(() => setIsShow((prev) => !prev), [])}>
                {label}
            </Button>

            {isShow ? (
                <div className={`mt-2 ${contentClassName ?? ''}`} style={contentStyle}>
                    {children}
                </div>
            ) : null}
        </div>
    );
};
